import React, { useCallback, useEffect, useReducer, useState } from "react";
import { PropTypes } from "prop-types";
import AddNewLeadDialog from "./AddNewLeadDialog/AddNewLeadDialog";
import { useSelector } from "react-redux";
import { useTranslate } from "../../../../../Hooks";
import { LeadsStatusEnum } from "../../../../../Enums";
import { GetLeadsReferredByData } from "../../../../../Helper";
import { GetLookupItemsByLookupTypeName } from "../../../../../Services";

const LeadQuickAddDialog = ({ isOpen, close }) => {
  const { translate } = useTranslate("HeaderView");
  const loginResponse = useSelector((state) => state.login.loginResponse);
  const reducer = useCallback((state, action) => {
    if (action.id !== "edit") return { ...state, [action.id]: action.value };
    return {
      ...action.value,
    };
  }, []);

  const defaultState = {
    leadClassId: null,
    salutationId: null,
    firstName: null,
    lastName: null,
    mobileNumbers: [],
    emailAddresses: [],
    languageId: null,
    nationalityId: null,
    cityId: null,
    districtId: null,
    communityId: null,
    propertyId: null,
    unitTypeId: null,
    numberOfBedrooms: [],
    numberOfBathrooms: [],
    priceFrom: null,
    priceTo: null,
    areaFrom: null,
    areaTo: null,
    leadStatusId: LeadsStatusEnum.Open.status,
    leadRatingId: null,
    mediaNameId: null,
    mediaDetailId: null,
    referredTo: null,
    referredBy: loginResponse && loginResponse.userId,
    isForAutoRotation: false,
    MethodOfContact: null,
    closedReasonId: null,
    data_completed: 16,
    propertyCampaignId: null,
    contactClassId: null,
    isSmartRotation: false,
  };

  const [state, setState] = useReducer(reducer, defaultState);
  const deafultSelected = {
    nationality: null,
    property: null,
    unitType: null,
    leadStatus: null,
    leadRating: null,
    clientSource: null,
    referredTo: null,
    referredBy: loginResponse,
    closeLeadResoun: null,
    campaign_name: null,
    language: null,
    contactClass: null,
    leadClass: null,
    salutation: null,
    mobileNumbers: null,
  };

  const [selected, setSelected] = useReducer(reducer, deafultSelected);
  
  const onSelectedChangeHandler = (valueId, newValue) => {
    setSelected({ id: valueId, value: newValue });
  };

  const GetLeadsReferredBy = useCallback(async () => {
    const leadReferred = await GetLeadsReferredByData();
    if (leadReferred) {
      setSelected({ id: "referredBy", value: leadReferred });
      setState({ id: "referredBy", value: leadReferred.id });
    }
  }, []);

  const GetLeadStatus = useCallback(async () => {
    let openLeadStatus = null;
    const res = await GetLookupItemsByLookupTypeName({
      lookUpName: "LeadStatus",
      pageSize: 100,
      pageIndex: 1,
    });
    if (!(res && res.status && res.status !== 200)) {
      openLeadStatus =
        res.result &&
        res.result.find((s) => s.lookupItemName === LeadsStatusEnum.Open.key);
      if (openLeadStatus) {
        setSelected({ id: "leadStatus", value: openLeadStatus });
        setState({ id: "leadStatusId", value: openLeadStatus.lookupItemId });
      } else {
        setSelected({ id: "leadStatus", value: null });
        setState({ id: "leadStatusId", value: null });
      }
    } else {
      setSelected({ id: "leadStatus", value: null });
      setState({ id: "leadStatusId", value: null });
    }
  }, []);

  useEffect(() => {
    GetLeadsReferredBy();
    GetLeadStatus();
  }, []);
  return (
    <AddNewLeadDialog
      isOpenChanged={() => {
        close();
        setState({ id: "edit", value: defaultState });
        setSelected({ id: "edit", value: defaultState });
      }}
      reloadData={() => {
        close();
        setState({ id: "edit", value: defaultState });
        setSelected({ id: "edit", value: defaultState });
      }}
      isQuickAdd
      state={state}
      isOpen={isOpen}
      selected={selected}
      setState={setState}
      onSelectedChangeHandler={onSelectedChangeHandler}
      setSelected={setSelected}
      translate={translate}
    />
  );
};

LeadQuickAddDialog.propTypes = {
  close: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};
export default LeadQuickAddDialog;
